enum TicketQueue {
    NewUnassigned = "NewUnassigned",
    MyOpenTickets = "MyOpenTickets",
    QualityUnassigned = "QualityUnassigned",
    LogisticUnassigned = "LogisticUnassigned",
    WaitingForVidendum = "WaitingForVidendum",
    WaitingForReporter = "WaitingForReporter",
    TicketsDashboard = "TicketsDashboard",
}

export default TicketQueue;